import axios from 'axios';

/**
 * 获取云平台基础属性
 */
export const getMetaData = () => {
  return axios.get('/api/metaData');
};

/**
 * 获取服务器串口列表
 */
export const getPorts = () => {
  return axios.get('/api/ports');
};

/**
 * 获取云平台已上传的校准文件
 */
export const getCalfiles = () => {
  return axios.get('/api/calfiles');
};

/**
 * 更新云平台基础属性
 */
export const updateMetaData = (params) => {
  return axios.post('/api/metaData', params);
};

/**
 * 更新云平台高级属性
 */
export const updateAdvancedMetaData = (params) => {
  return axios.post('/api/metaData?isAdvanced=true', params);
};

/**
 * 更新云平台方向图示
 */
export const updateIndicator = (params) => {
  return axios.post('/api/metaData/indicator', params);
};

/**
 * 更新云平台『方向图示』在项目展示图中的坐标
 */
export const updateIndicatorPosition = (params) => {
  return axios.post('/api/metaData/indicatorPosition', params);
};

/**
 * 测试振动位移计
 */
export const testSdmpro = ({ register, cmd, payload }) => {
  return axios.post('/api/test/sdmpro', { register, cmd, options: payload });
};

/**
 * 删除云平台校准文件
 */
export const deleteCalfile = ({ filename }) => {
  return axios.post('/api/calfiles/delete', { filename });
};

/**
 * 内部登录接口
 */
export const requestLogin = (params) => {
  return axios.post('/session/internalLogin', params);
};

